'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_CreatePolicyPage$() {
}
export { $c_Lpresto_CreatePolicyPage$ as $c_Lpresto_CreatePolicyPage$ };
$p = $c_Lpresto_CreatePolicyPage$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CreatePolicyPage$;
/** @constructor */
function $h_Lpresto_CreatePolicyPage$() {
}
export { $h_Lpresto_CreatePolicyPage$ as $h_Lpresto_CreatePolicyPage$ };
$h_Lpresto_CreatePolicyPage$.prototype = $p;
$p.dl = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$();
});
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return (-1718793955);
});
$p.l = (function() {
  return "CreatePolicyPage";
});
$p.r = (function() {
  return 0;
});
$p.s = (function() {
  return "CreatePolicyPage";
});
$p.j = (function(n) {
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
var $d_Lpresto_CreatePolicyPage$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CreatePolicyPage$, "presto.CreatePolicyPage$", ({
  EP: 1,
  a2: 1,
  b: 1,
  c: 1,
  a: 1,
  e: 1,
  g: 1,
  m: 1
}));
export { $d_Lpresto_CreatePolicyPage$ as $d_Lpresto_CreatePolicyPage$ };
var $n_Lpresto_CreatePolicyPage$;
function $m_Lpresto_CreatePolicyPage$() {
  if ((!$n_Lpresto_CreatePolicyPage$)) {
    $n_Lpresto_CreatePolicyPage$ = new $c_Lpresto_CreatePolicyPage$();
  }
  return $n_Lpresto_CreatePolicyPage$;
}
export { $m_Lpresto_CreatePolicyPage$ as $m_Lpresto_CreatePolicyPage$ };
//# sourceMappingURL=presto.-Create-Policy-Page$.js.map
